import { hookstate } from '@hookstate/core'

const loadState = ()=>{
    
    let vlConfigState = null;
   
    if(!vlConfigState){
        vlConfigState = {
            SEARCH_INDEX_COUNT: {
                setting_name: "SEARCH_INDEX_COUNT",
                int_value: 6,
                bool_value: undefined,
                string_value: undefined,
                local_only: false
            },
            RETURN_ALL_RAG_RESULTS: {
                setting_name: "RETURN_ALL_RAG_RESULTS",
                bool_value: false,
                int_value: undefined,
                string_value: undefined,
                local_only: true
            },
            IS_LOADED: false
        };
    }
    return vlConfigState;
}

const virtualLibrarianSettingsStore = hookstate(loadState());

export default virtualLibrarianSettingsStore; 